import {formatDateToYYYYMMDD} from '../utility/dateHelper';

export const GetFormattedOfflineOrder = (apiResponse = {}) => {
    const {
        orders,
        totalRecords = '',
        totalPages = '',
        pageSize = '',
        currentPage = '',
        activeCount = '',

    } = apiResponse;

    const formattedOrder = orders?.map(GetOrders);
    return {
        data: formattedOrder || [],
        totalRecords,
        totalPages,
        pageSize,
        currentPage,
        activeCount,
    };
};

// Helper function to map individual items
const GetOrders = (item = {}) => {
    const {
        orderId = "",
        orderState= "",
        storeId = "",
        updatedDate = "",
        soldCustomerId = "",
        orderType = "",
    } = item;

    return {
        orderId,
        orderState,
        storeId,
        updatedDate: formatDateToYYYYMMDD(updatedDate),
        soldCustomerId,
        orderType
    };
};
